import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useAxios from "../utils/useAxios";
import { 
 
  FaEnvelope, 
  FaPhone, 
  FaBriefcase, 
  FaKey, 
 
  FaCheckCircle,
  FaTimesCircle,
  FaInfoCircle
} from "react-icons/fa";
import { useSidebar } from "../context/SidebarContext";
import { useAuth } from "../context/AuthContext";
import Swal from "sweetalert2";

const RoleEmployePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const api = useAxios();
  const { sidebarVisible } = useSidebar();
  const { user: currentUser } = useAuth();

  const [employee, setEmployee] = useState(null);
  const [roles, setRoles] = useState([]);
  const [allPermissions, setAllPermissions] = useState([]);
  const [employeePermissions, setEmployeePermissions] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("role");
  const [hasRole, setHasRole] = useState(false);



  const styles = {
    container: { 
      marginLeft: sidebarVisible ? 250 : 0, 
      padding: "20px", 
      backgroundColor: "#f5f7fa", 
      minHeight: "100vh",
      transition: "margin-left 0.3s ease"
    },
    header: { 
      display: "flex", 
      justifyContent: "space-between", 
      alignItems: "center", 
      marginBottom: "20px" 
    },
    backButton: {
      backgroundColor: "#6c757d",
      color: "white",
      padding: "10px 15px",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "14px",
      fontWeight: "bold"
    },
    titleContainer: { 
      display: "flex", 
      alignItems: "center",
      gap: "10px",      
      paddingLeft: "40px",
    },
    title: { 
      color: "#1B019B", 
      display: "flex", 
      alignItems: "center", 
      gap: "10px",
    },
    card: { 
      backgroundColor: "white", 
      borderRadius: "10px", 
      padding: "25px", 
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)", 
      maxWidth: "900px", 
      margin: "0 auto" 
    },
    profileSection: { 
      display: "flex", 
      alignItems: "center", 
      gap: "25px", 
      marginBottom: "30px", 
      paddingBottom: "25px", 
      borderBottom: "1px solid #eee" 
    },
    profileImage: { 
      width: "140px", 
      height: "140px", 
      borderRadius: "10px", 
      objectFit: "cover", 
      border: "3px solid #1B019B" 
    },
    profileInfo: { 
      flex: 1 
    },
    employeeName: { 
      margin: "0 0 10px 0", 
      color: "#333", 
      fontSize: "24px",
      fontWeight: "bold"
    },
    infoText: { 
      display: "flex", 
      alignItems: "center", 
      margin: "8px 0", 
      color: "#555", 
      fontSize: "15px" 
    },
    icon: { 
      marginRight: "10px", 
      color: "#1B019B",
      width: "16px"
    },
    currentRole: { 
      backgroundColor: "#e8f5e9", 
      padding: "10px 15px", 
      borderRadius: "5px", 
      marginTop: "10px", 
      display: "inline-block", 
      fontWeight: "bold", 
      color: "#2e7d32" 
    },
    tabs: {
      display: "flex",
      borderBottom: "1px solid #ddd",
      marginBottom: "20px"
    },
    tab: {
      padding: "12px 20px",
      cursor: "pointer",
      borderBottom: "3px solid transparent",
      fontWeight: "bold",
      color: "#666",
      transition: "all 0.3s"
    },
    activeTab: {
      color: "#1B019B",
      borderBottom: "3px solid #1B019B"
    },
    roleSection: {
      marginTop: "20px"
    },
    label: { 
      fontWeight: "bold", 
      marginBottom: "10px", 
      display: "block", 
      color: "#333", 
      fontSize: "16px" 
    },
    select: { 
      width: "100%", 
      padding: "12px", 
      borderRadius: "5px", 
      border: "1px solid #ddd", 
      fontSize: "15px", 
      marginBottom: "20px", 
      backgroundColor: "#f9f9f9" 
    },
    permissionsContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
      gap: "15px",
      marginTop: "15px"
    },
    permissionCard: {
      border: "1px solid #ddd",
      borderRadius: "8px",
      padding: "15px",
      backgroundColor: "#f9f9f9",
      cursor: "pointer",
      transition: "all 0.2s"
    },
    selectedPermission: {
      borderColor: "#1B019B",
      backgroundColor: "#e6f0ff"
    },
    permissionHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "10px"
    },
    permissionName: {
      fontWeight: "bold",
      color: "#333"
    },
    permissionDescription: {
      fontSize: "14px",
      color: "#666",
      marginTop: "5px"
    },
    buttonContainer: { 
      display: "flex", 
      gap: "15px", 
      flexWrap: "wrap",
      marginTop: "25px"
    },
    assignButton: { 
      backgroundColor: "#1B019B", 
      color: "white", 
      padding: "12px 25px", 
      border: "none", 
      borderRadius: "5px", 
      cursor: "pointer", 
      fontSize: "15px", 
      fontWeight: "bold", 
      transition: "background-color 0.3s", 
      display: "flex", 
      alignItems: "center",
      gap: "8px"
    },
    permissionsButton: { 
      backgroundColor: "#28a745", 
      color: "white", 
      padding: "12px 25px", 
      border: "none", 
      borderRadius: "5px", 
      cursor: "pointer", 
      fontSize: "15px", 
      fontWeight: "bold", 
      transition: "background-color 0.3s", 
      display: "flex", 
      alignItems: "center",
      gap: "8px"
    },
    loading: { 
      textAlign: "center", 
      padding: "40px", 
      fontSize: "18px", 
      color: "#666" 
    },
    error: { 
      textAlign: "center", 
      padding: "40px", 
      fontSize: "18px", 
      color: "#d32f2f" 
    },
    infoBox: {
      backgroundColor: "#e7f3ff",
      border: "1px solid #b8daff",
      borderRadius: "5px",
      padding: "15px",
      marginBottom: "20px",
      display: "flex",
      alignItems: "flex-start",
      gap: "10px"
    },
    noPermissionsMessage: {
      textAlign: "center",
      padding: "20px",
      backgroundColor: "#f8f9fa",
      borderRadius: "8px",
      color: "#6c757d",
      marginTop: "20px"
    }
  };

useEffect(() => {
  const fetchData = async () => {
    if (!currentUser) {
      // Utilisateur déconnecté → ne pas charger les données
      return;
    }

    try {
      setLoading(true);

      const [empRes, roleRes, empPermRes] = await Promise.all([
        api.get(`/employes/${id}/`),
        api.get("/roles/"),
        api.get(`/permissions/employe/${id}/`)
      ]);

      setEmployee(empRes.data);
      setRoles(roleRes.data);

      const isSuperAdmin = currentUser?.is_super_admin;

      if (isSuperAdmin) {
        setAllPermissions(empPermRes.data.all_permissions || []);
        setSelectedPermissions(empPermRes.data.employee_permissions || []);
        setHasRole(!!empRes.data.role);
        setSelectedRole(
          roleRes.data.find(r => r.nom === empRes.data.role)?.id || ""
        );
      } else {
        const hasRole = !!empRes.data.role;
        setHasRole(hasRole);

        const roleId = roleRes.data.find(r => r.nom === empRes.data.role)?.id || "";
        setSelectedRole(roleId);

        if (roleId) {
          const rolePermRes = await api.get(`/permissions/role/${roleId}/`);
          setAllPermissions(rolePermRes.data);
        } else {
          setAllPermissions([]);
        }

        const empPermissionIds = empPermRes.data.employee_permissions || [];
        setSelectedPermissions(empPermissionIds);
      }

    } catch (err) {
      console.error("Erreur lors du chargement des données:", err);

      if (err.response?.status === 401) {
        // Utilisateur déconnecté → ne pas afficher le message d'erreur
        return;
      }

      Swal.fire("Erreur", "Impossible de charger les données.", "error");
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [id, currentUser]);



  const handleAssignRole = async () => {
    if (!selectedRole) {
      Swal.fire("Erreur", "Veuillez choisir un rôle.", "warning");
      return;
    }
    
    try {
      const res = await api.post(`/employes/${id}/assign-role/`, { 
        role_id: selectedRole 
      });
      
      // Mettre à jour les données de l'employé
      setEmployee(prev => ({ ...prev, role: res.data.role }));
      setHasRole(true); // Maintenant l'employé a un rôle
      
      // Recharger les permissions du rôle
      const rolePermRes = await api.get(`/permissions/role/${selectedRole}/`);
      setAllPermissions(rolePermRes.data);
      
      Swal.fire({
        title: "Succès",
        text: "Rôle attribué avec succès.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false
      });
      
      // Basculer vers l'onglet des permissions
      setActiveTab("permissions");
    } catch (err) {
      console.error("Erreur lors de l'attribution du rôle:", err);
      Swal.fire("Erreur", "Impossible d'attribuer le rôle.", "error");
    }
  };

  const handlePermissionToggle = (permissionId) => {
    if (selectedPermissions.includes(permissionId)) {
      setSelectedPermissions(selectedPermissions.filter(id => id !== permissionId));
    } else {
      setSelectedPermissions([...selectedPermissions, permissionId]);
    }
  };

  const handleSavePermissions = async () => {
    try {
      const res = await api.post(`/employes/${id}/assign-permissions/`, {
        permission_ids: selectedPermissions
      });
      
      // Mettre à jour les permissions de l'employé
      setEmployeePermissions(res.data.permissions || []);
      
      Swal.fire({
        title: "Succès",
        text: "Permissions mises à jour avec succès.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false
      });
    } catch (err) {
      console.error("Erreur lors de la sauvegarde des permissions:", err);
      
      if (err.response?.status === 403) {
        Swal.fire("Erreur", "Vous ne pouvez pas modifier vos propres permissions.", "error");
      } else {
        Swal.fire("Erreur", "Impossible de sauvegarder les permissions.", "error");
      }
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) return <div style={{...styles.loading, marginLeft: sidebarVisible ? 250 : 0}}>Chargement...</div>;
  if (!employee) return <div style={{...styles.error, marginLeft: sidebarVisible ? 250 : 0}}>Employé introuvable.</div>;

  const isNotCurrentUser = currentUser && employee.id !== currentUser.id;
  const currentRole = roles.find(role => role.id === selectedRole);

  return (
    <div style={styles.container}>
      <div style={styles.header}>

        <div style={styles.titleContainer}>
          <h2 style={styles.title}>
             Gestion du rôle et des permissions
          </h2>
        </div>
      </div>

      <div style={styles.card}>
        <div style={styles.profileSection}>
          <img
            src={employee.image ? `${employee.image}` : "/default.jpg"}
            alt="Profil"
            style={styles.profileImage}
            onError={(e) => e.target.src = "/default.jpg"}
          />
          <div style={styles.profileInfo}>
            <h2 style={styles.employeeName}>{employee.last_name} {employee.first_name}</h2>
            <p style={styles.infoText}><FaEnvelope style={styles.icon} /> {employee.email}</p>
            <p style={styles.infoText}><FaPhone style={styles.icon} /> {employee.telephone || "Non renseigné"}</p>
            <p style={styles.infoText}><FaBriefcase style={styles.icon} /> {employee.poste || "Non renseigné"}</p>
            <div style={styles.infoText}>
              <strong>Rôle actuel :</strong> {employee.role ? (
                <span style={styles.currentRole}>{employee.role}</span>
              ) : "Pas de rôle attribué"}
            </div>
          </div>
        </div>

        {!isNotCurrentUser && (
          <div style={styles.infoBox}>
            <FaInfoCircle style={{color: "#0c63e4", marginTop: "2px"}} />
            <div>
              <strong>Information :</strong> Vous ne pouvez pas modifier vos propres permissions.
            </div>
          </div>
        )}


        <div style={styles.tabs}>
          <div 
            style={{...styles.tab, ...(activeTab === "role" ? styles.activeTab : {})}}
            onClick={() => setActiveTab("role")}
          >
            Attribuer un rôle
          </div>
          {(hasRole || currentUser?.is_super_admin) && (
            <div 
              style={{...styles.tab, ...(activeTab === "permissions" ? styles.activeTab : {})}}
              onClick={() => setActiveTab("permissions")}
            >
              Gérer les permissions
            </div>
          )}

        </div>

        {activeTab === "role" && (
          <div style={styles.roleSection}>
            <label style={styles.label}>Sélectionner un rôle :</label>
            <select 
              value={selectedRole} 
              onChange={(e) => setSelectedRole(e.target.value)} 
              style={styles.select}
            
            >
              <option value="">-- Choisir un rôle --</option>
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.nom}
                </option>
              ))}
            </select>

            {currentRole && currentRole.description && (
              <div style={styles.infoBox}>
                <FaInfoCircle style={{color: "#0c63e4", marginTop: "2px"}} />
                <div>
                  <strong>Description du rôle :</strong> {currentRole.description}
                </div>
              </div>
            )}

      
              <div style={styles.buttonContainer}>
                <button
                  onClick={handleAssignRole}
                  style={styles.assignButton}
                  onMouseOver={(e) => e.target.style.backgroundColor = "#150178"}
                  onMouseOut={(e) => e.target.style.backgroundColor = "#1B019B"}
                >
                  <FaCheckCircle />
                  Attribuer le rôle
                </button>
              </div>
            
          </div>
        )}

          {activeTab === "permissions" && (hasRole || currentUser?.is_super_admin) && (
            <div style={styles.roleSection}>

            <label style={styles.label}>Sélectionner les permissions :</label>
            <p style={{color: "#666", marginBottom: "15px"}}>
              Cochez les permissions que vous souhaitez attribuer à cet employé.
            </p>

            {allPermissions.length > 0 ? (
              <div style={styles.permissionsContainer}>
                {allPermissions.map(permission => (
                  <div 
                    key={permission.id}
                    style={{
                      ...styles.permissionCard,
                      ...(selectedPermissions.includes(permission.id) ? styles.selectedPermission : {})
                    }}
                    onClick={() => isNotCurrentUser && handlePermissionToggle(permission.id)}
                  >
                    <div style={styles.permissionHeader}>
                      <div style={styles.permissionName}>{permission.nom}</div>
                      {selectedPermissions.includes(permission.id) ? (
                        <FaCheckCircle style={{color: "#28a745"}} />
                      ) : (
                        <FaTimesCircle style={{color: "#dc3545"}} />
                      )}
                    </div>
                    <div style={styles.permissionDescription}>
                      {permission.description || "Aucune description disponible"}
                    </div>
                    <div style={{fontSize: "12px", color: "#888", marginTop: "8px"}}>
                      Code: {permission.code}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={styles.noPermissionsMessage}>
                <FaInfoCircle style={{fontSize: "24px", marginBottom: "10px"}} />
                <p>Aucune permission disponible pour ce rôle.</p>
              </div>
            )}

            {isNotCurrentUser && allPermissions.length > 0 && (
              <div style={styles.buttonContainer}>
                <button
                  onClick={handleSavePermissions}
                  style={styles.permissionsButton}
                  onMouseOver={(e) => e.target.style.backgroundColor = "#218838"}
                  onMouseOut={(e) => e.target.style.backgroundColor = "#28a745"}
                >
                  <FaKey />
                  Enregistrer les permissions
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RoleEmployePage;